<template>
  <Breadcrumbs
      title="Goods Received Note"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Goods Received Note', path: '/grn' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <orderForm/>
    </div>
  </div>
</template>

<script>

import orderForm from './grnhomeForm.vue'
export default {
  name: 'indexList',
  components: {

    orderForm,

  },


}

</script>
